module.exports = __webpack_public_path__ + "img/PG3-2-311x208.a6b25ae0.png";